import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    fetchToast: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchToastSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload; // ✅ transformed data
    },
    fetchToastFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchToast, fetchToastSuccess, fetchToastFailure } =
  toastSlice.actions;

export default toastSlice.reducer;
